import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * `<labs-footer>` displays the app footer.
 */
@Component({
  selector: 'labs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  @Input() text: string;
}
